<template>
  <div class="successCon" >
    <div class="qrMain">
      <div class="header-section">
        
        <h2 class="title">电子凭证</h2>
        <p class="subtitle">DIGTAL PASS</p>
      </div>

      <div class="qr-container">

        <qrcode-vue
          :value="visitorObj.VistorVisCard"
          :size="200"
          class="qrcode"
        ></qrcode-vue>
      </div>

      <div class="tip-section">
        <div class="tip-icon">📋</div>
        <p class="tip-text">请向工作人员出示此二维码</p>
        <p class="tip-desc">Please present this QR code to the staff</p>
      </div>
      <div class="back-btn-wrap">
        <van-button type="primary" color="#003df2" round @click="goBack">返回
          <br /><span class="btn-en">Back</span>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import api from '@/api'
import { useStore } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
import { useRouter } from 'vue-router'
import { Button as VanButton } from 'vant'

const router = useRouter()
const store = useStore()
const VisitorID = computed(() => store.state.VisitorID)
const isWeX = computed(() => store.state.isWeX)
const mainColor = computed(() => store.state.mainColor || '#4a90e2')
const visitorObj = ref({})

const getMsg = async () => {
  try {
    const res = await api.getVisitorApi({ VisitorID: VisitorID.value })
    const jmRes = JSON.parse(decryptionECB(res.data))
    visitorObj.value = jmRes
  } catch (error) {
    console.error('获取访客信息失败:', error)
  }
}

const goBack = () => {
  router.go(-1) // 返回上一页
}

onMounted(() => {
  getMsg()
  if (isWeX.value) {
    wx.getWXSign()
  }
})
</script>

<style lang="less" scoped>
.btn-en {
    font-size: 10px;
  }
.successCon {
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  //background: linear-gradient(160deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  box-sizing: border-box;
}

.qrMain {
  width: 100%;
  max-width: 360px;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  padding: 30px;
  position: relative;

  .header-section {
    text-align: center;
    margin-bottom: 30px;

    .title {
      font-size: 24px;
      font-weight: 700;
      color: #333;
      margin: 0 0 5px 0;
      background: linear-gradient(90deg, v-bind(mainColor), #6c5ce7);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .subtitle {
      font-size: 14px;
      color: #999;
      margin: 0;
      letter-spacing: 1px;
    }
  }

  .qr-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px 0;
    padding: 25px;
    background: #f8f9ff;
    border-radius: 16px;

    .qr-overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: none;

      svg {
        position: absolute;
        width: 40px;
        height: 40px;
        stroke: v-bind(mainColor);

        &.corner-tl { top: 25px; left: 25px; }
        &.corner-tr { top: 25px; right: 25px; }
        &.corner-bl { bottom: 25px; left: 25px; }
        &.corner-br { bottom: 25px; right: 25px; }
      }
    }

    .qrcode {
      position: relative;
      z-index: 1;
      border-radius: 8px;
    }
  }

  .info-section {
    margin: 30px 0;
    padding: 20px;
    background: #f9f9ff;
    border-radius: 12px;

    .info-item {
      display: flex;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-weight: 600;
        color: #555;
        min-width: 50px;
        margin-right: 10px;
      }

      .value {
        color: #333;
        flex: 1;
        text-align: left;
      }
    }
  }

  .tip-section {
    text-align: center;
    padding-top: 20px;
    border-top: 1px dashed #e0e0e0;

    .tip-icon {
      font-size: 28px;
      margin-bottom: 10px;
    }

    .tip-text {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 0 0 5px 0;
    }

    .tip-desc {
      font-size: 13px;
      color: #999;
      margin: 0;      
    }
  }

  .back-btn-wrap {
    text-align: center;
    margin-top: 8vw;
    padding-bottom: 5vw;

    .van-button {
      width: 50vw;
      border-radius: 10px !important;
    }
  }
}

// 响应式设计
@media (max-width: 480px) {
  .qrMain {
    padding: 20px;
    margin: 15px;

    .header-section {
      margin-bottom: 20px;
    }

    .qr-container {
      padding: 20px;
    }

    .info-section {
      padding: 15px;
    }
  }
}

@media screen and (min-width: 768px) {
  .qrMain {
    .back-btn-wrap {
      margin-top: 40px;

      .van-button {
        width: 200px;
      }
    }
  }
}
</style>
